import ScalarIconSparkle_vue_vue_type_script_setup_true_lang_default from "./ScalarIconSparkle.vue.script.js";
//#region src/components/ScalarIconSparkle.vue
var ScalarIconSparkle_default = ScalarIconSparkle_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconSparkle_default as default };

//# sourceMappingURL=ScalarIconSparkle.js.map